const ERROR_TOLERANCE = 1e-9;

export function approxEquals(a: number, b: number, eps = ERROR_TOLERANCE): boolean {
  return Math.abs(a - b) <= eps;
}

export function approxLTE(a: number, b: number, eps = ERROR_TOLERANCE): boolean {
  return a < b || approxEquals(a, b, eps);
}

export function approxGTE(a: number, b: number, eps = ERROR_TOLERANCE): boolean {
  return a > b || approxEquals(a, b, eps);
}

export function approxGT(a: number, b: number, eps = ERROR_TOLERANCE): boolean {
  return a > b && !approxEquals(a, b, eps);
}

export function approxLT(a: number, b: number, eps = ERROR_TOLERANCE): boolean {
  return a < b && !approxEquals(a, b, eps);
}
export type Window = [number, number];

export function isApproxWindowSubset(src: Window, target: Window, eps = ERROR_TOLERANCE): boolean {
  return approxGTE(src[0], target[0], eps) && approxLTE(src[1], target[1], eps);
}
